import { createFileRoute } from "@tanstack/react-router";
import { HokageServiceEndedTemplate } from "~/features/hokageMigration/HokageServiceEndedTemplate";

export const Route = createFileRoute("/hokage-service-ended")({
  component: HokageServiceEndedTemplate,
});
